
import { useEffect, useState } from "react";
import { EventCode } from "../../enums/index.enum";
import { ProductDetail } from '../productDetail/productDetail.component';
import ProductTypeCode from "../../enums/productTypeCode.enum"
import ProductHelper from "../../helpers/product.helper";
import ProductDetailSection from "../../enums/productDetailSection.enum";
import { getProductTypeByCode } from "../../services/productType.service";
import { CheckOutlined } from "@ant-design/icons"
import { FaqCode } from '../../enums/index.enum';
import { listFaqs } from '../../services/faq.service';

export const Biobeat = () => {

  const [productType, setProductType] = useState()
  const [sections, setSections] = useState(null)
  const [faqs, setFaqs] = useState([])
  
  
  // init + get prices
  useEffect(() => {
    const fetchProductType = async () => {
      const response = await getProductTypeByCode(ProductTypeCode.BIOBEAT)
      setProductType(response)
    };
    fetchProductType(); 
  }, []);

  useEffect(() => {
    const fetchFaqs = async () => {
      const faqs = await listFaqs({filter: {code: {$in: [
        FaqCode.BIOBEAT_HOW_LONG,
        FaqCode.BIOBEAT_VITAL_SIGNS,
        FaqCode.BIOBEAT_BETTER_THAN_ARMCUFF,
        FaqCode.BIOBEAT_WHO_SHOULD_USE,
        FaqCode.BIOBEAT_HOW_IT_WORKS,
        FaqCode.BIOBEAT_ACCURACY,
        FaqCode.BIOBEAT_HOW_LONG_TO_GET_RESULTS,
        FaqCode.BIOBEAT_WHERE_AVAILABLE,
        FaqCode.BIOBEAT_HOW_TO_WEAR,
        FaqCode.BIOBEAT_SETUP,
        FaqCode.BIOBEAT_DOCTOR_REVIEW,
        FaqCode.BIOBEAT_INSURANCE,
        FaqCode.BIOBEAT_PRESCRIPTION,
        FaqCode.BIOBEAT_PROVIDER,
        ]}}})
      setFaqs(faqs)
    }
    fetchFaqs()
  }, [])



  // set product attributes
  useEffect(() => {
    if (!productType || !faqs) return
  
    setSections([
      { type: ProductDetailSection.HERO,
        data: {
          title: productType.title,
          memberPrice: ProductHelper.getMemberPrice(productType.cost),
          originalPrice: productType.cost,
          oneliner: "An FDA-cleared, single-use device that continuously tracks your blood pressure and other vital signs over a 24 hour period.",
          cta: {
            text: "Get Now",
            url: `/flow/${productType.flowType}`
          },
          hasKlarna: true,
          photos: [
   
              {
                original: "/img/biobeat.png", 
                thumbnail: "/img/biobeat.png"
              },

              {
                original: "/img/biobeat-ad.png",
                thumbnail:  "/img/biobeat-ad.png"
              },
              {
                original: "/img/hsa-fsa-eligible-hero.webp",
                thumbnail: "/img/hsa-fsa-eligible-hero.webp"
              }
          ],
          points: [
            <><CheckOutlined className="point-icon"/>Accurate detection of hypertension vs. single readings</>,
            <><CheckOutlined className="point-icon"/>Does not interfere with your daily routine</>,
            <><CheckOutlined className="point-icon"/>Comfortable wear and easy set-up</>,
            <><CheckOutlined className="point-icon"/>HSA / FSA cards accepted</>,
          ],
          faqs: faqs
          
        },
      },

      { type: ProductDetailSection.DIRECTIONS,
        data: [
            {
                title: "Order the Biobeat",
                description: "After you purchase, you'll receive your Biobeat Chest Monitor in the mail within one week. Shipping is free.",
                image: "/img/biobeat-kit.png"
            },
            {
                title: "Wear Biobeat for 24 hours",
                description: "The Biobeat Chest Monitor can be easily hidden under your clothes. You can go about your day as usual.",
                image: "/img/biobeat/biobeat-woman-square.png"
            },
            {
                title: "Receive your results",
                description: "Results are reviewed by a physician and available within 1 business day. A report and game plan will be available as well.",
                image: "/img/biobeat/biobeat-sample-report-square.png"
            },

        ],
      },

      { type: ProductDetailSection.FAQ,
        title: 'Frequently Asked Questions',
        data: faqs.slice(4),
      },

    ])
  
  }, [productType, faqs])


  return (
    sections && <div className="longevity-panel">

      <ProductDetail 
        sections={sections}
        trackCode={EventCode.VISIT_HEART_HEALTH_TEST}
      />

     
    </div>
  )

}
